__webpack_require__.add = function registerModules(modules) { Object.assign(__webpack_require__.m, modules) }
